import React, { useEffect } from 'react'
import { SideNav, ListItem } from '@deere/ux.uxframe-react'
import { getTranslation } from '../utils/utils';
import { SCBM_SECCIO_CODES, CRS_SURVEY_CODES } from '../utils/surveyLiterals'

export default function LeftMenu({ actLink, survey,isNewFrameWork, setNavMenuHeight }) {

    const leftNavMenuBar = document.getElementById("leftNavMenuBar");
    const navMenuHeight = leftNavMenuBar ? leftNavMenuBar.offsetHeight : 0;

    useEffect(()=>{
        if(navMenuHeight && setNavMenuHeight){
            setNavMenuHeight(navMenuHeight); // Using this in cases where we are using LeftRelatedLinks Component
        }
    }, [navMenuHeight])

    const navbarStyles = {
        width: '230px',
        maxWidth: '230px'
    }

    const navbarStylesNew = {
        width: '95%',
        maxWidth: '14.5rem'
    }

    const pages = [];
    if(survey.code===CRS_SURVEY_CODES.SCBM){
        pages.push(survey.sections.find(e => e.code === SCBM_SECCIO_CODES.BS && e.active));
        pages.push(survey.sections.find(e => e.code === SCBM_SECCIO_CODES.LB && e.active));
        pages.push(survey.sections.find(e => e.code === SCBM_SECCIO_CODES.CC && e.active));
        pages.push(survey.sections.find(e => e.code === SCBM_SECCIO_CODES.FL && e.active));
        pages.push(survey.sections.find(e => e.code === SCBM_SECCIO_CODES.AC && e.active));
        pages.push(survey.sections.find(e => e.code === SCBM_SECCIO_CODES.CS && e.active));
        pages.push(survey.sections.find(e => e.code === SCBM_SECCIO_CODES.OTH && e.active));
    }else{
        survey.sections.sort((a,b) => (a.showOrder > b.showOrder)? 1 : -1).map((section,index) => section.active ? pages.push(section): '' )        
    }

    return (
        <SideNav id="leftNavMenuBar" className="d-sm-block mb-3 position-sticky fixed-top" style={isNewFrameWork ? navbarStylesNew:navbarStyles} ariaLabel=''>
            {
               pages.length>0 && pages.map((menOption, index) =>                
               menOption && <ListItem key={'men' + index} className='nav-item'>
                        <a className={'nav-link ' + actLink[index]} href={'#' + menOption.description}>{getTranslation(menOption,'description')}</a>
                    </ListItem>)
            }
        </SideNav>
    )
}